import React from 'react';
import '../Mini-div/MiniDiv.css';



function MiniDiv(props){
  return (
    <div className='mini-div'  data-aos="zoom-in">
      <div className='image'>
            <img className='img1' src={props.imgsrc} title={props.title} alt=''/>
      </div>
    </div>
  )
}

export default MiniDiv;